export const llistaVocabulary: {
  title: string;
  token: string;
}[] = [
  {
    title: 'Cap de llista',
    token: '0',
  },
  {
    title: 'Membre de la llista',
    token: '1',
  },
];
